var _mask, _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserPlaceholder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 111,
    height: 111
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55.5,
    cy: 55.5,
    r: 55.5,
    fill: "#FFFBEB"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.8305 37.2565C69.7383 42.2091 73.4569 41.7817 79.0621 49.7047C84.9936 58.089 87.5833 56.757 90.2925 59.2868C93.0017 61.8166 95.4046 46.4243 84.5357 37.606C77.5583 31.945 67.9226 32.3039 68.8305 37.2565Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3233 30.7142C72.123 35.9916 79.0295 38.3147 84.6347 46.2377C90.5662 54.622 87.4935 61.8431 90.2028 64.3729C92.912 66.9027 98.8622 43.5639 89.2133 33.4251C78.028 21.6718 74.5235 25.4368 73.3233 30.7142Z",
    fill: "#D1C394"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7002 38.2565C42.7923 43.2091 39.0737 42.7817 33.4685 50.7047C27.537 59.089 24.9474 57.757 22.2381 60.2868C19.5289 62.8166 17.126 47.4243 27.9949 38.606C34.9723 32.945 44.608 33.3039 43.7002 38.2565Z",
    fill: "#AEA075"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2073 31.7142C40.4076 36.9916 33.5011 39.3147 27.8959 47.2377C21.9644 55.622 25.0371 62.8431 22.3278 65.3729C19.6186 67.9027 13.6684 44.5639 23.3173 34.4251C34.5027 22.6718 38.0071 26.4368 39.2073 31.7142Z",
    fill: "#D1C294"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 115C90 115 77 127 55.5 127C35.5 127 23.5 116.5 23.5 116.5C23.5 99.3792 33 49.5 55.5 49.5C75.5 49.5 90 97.8792 90 115Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3482 28.0047C15.0688 28.5707 38.2225 79.2538 40.6943 83.7109C43.1661 88.1681 70.166 88.1679 72.6636 83.2651C75.1612 78.3623 97.6276 27.4387 56.3482 28.0047Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3845 76.3819C56.3845 76.3819 63.5515 71.529 63.599 80.1321C63.6333 86.3308 60.3991 90.6876 56.3756 90.7098C52.352 90.732 49.0626 86.4114 49.0284 80.2126C48.9832 72.0349 56.3845 76.3819 56.3845 76.3819Z",
    fill: "#C18282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.422 76.5C56.422 76.5 43.1924 86.5407 43.1059 75.1525C43.0436 66.9471 49.0055 61.1583 56.422 61.102C63.8384 61.0457 69.901 66.7432 69.9633 74.9486C70.0455 85.7736 56.422 76.5 56.422 76.5Z",
    fill: "#AFA16E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9773 66.7024C61.9988 68.8345 59.4988 71.9695 56.475 72C53.4512 72.0305 51.0488 68.945 51.0273 66.8129C51.0058 64.6807 53.4512 64.0857 56.475 64.0552C59.4988 64.0247 61.9558 64.5703 61.9773 66.7024Z",
    fill: "#3D3D3D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4443 55.4493C49.577 57.3817 47.5916 55.5765 45.3062 55.7334C43.0208 55.8903 41.3008 57.9499 41.1681 56.0174C41.0355 54.085 42.8527 53.441 45.1381 53.2841C47.4235 53.1272 49.3117 53.5169 49.4443 55.4493Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.059 55.4493C63.9263 57.3817 65.9116 55.5765 68.1971 55.7334C70.4825 55.8903 72.2025 57.9499 72.3352 56.0174C72.4678 54.085 70.6506 53.441 68.3652 53.2841C66.0798 53.1272 64.1916 53.5169 64.059 55.4493Z",
    fill: "#3D3D3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 56.75,
    y1: 50,
    x2: 56.75,
    y2: 127.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#897E59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0D2A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 56.5,
    y1: 28,
    x2: 56.5,
    y2: 87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1C394"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC9F6E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPlaceholder1);
export default __webpack_public_path__ + "static/media/user-placeholder-1.4f8ef7c2edd021352b7dc917d88f2a4c.svg";
export { ForwardRef as ReactComponent };